import type { ButtonHTMLAttributes, ReactNode } from 'react'

import { Spinner } from '@/components/ui/Spinner'

import { CTAButtonElement } from './styles'

interface CTAButtonProps extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'children'> {
  children: ReactNode
  /** dark = 기본 CTA(검정), brand = 결제 등 강조 CTA(주황) */
  variant?: 'dark' | 'brand'
  /**
   * 로딩 중 — 텍스트 대신 스피너 노출. 비활성(회색) 처리와 달리 컬러 배경을 유지하고
   * 클릭만 차단한다 (Figma 3847-22459/22493 Loading 상태). disabled 와는 별개로 사용.
   */
  loading?: boolean
}

export function CTAButton({
  children,
  type = 'button',
  variant = 'dark',
  loading = false,
  onClick,
  ...rest
}: CTAButtonProps) {
  return (
    <CTAButtonElement
      type={type}
      variant={variant}
      aria-busy={loading || undefined}
      onClick={loading ? undefined : onClick}
      {...rest}
    >
      {loading ? (
        <Spinner
          size='medium'
          color='#ffffff'
        />
      ) : (
        children
      )}
    </CTAButtonElement>
  )
}
